var IpcPthPadGeneratorData = require('./ipcPthPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var PthComponentAttribute = require('./pthComponentAttribute.js');
var IPCRules = require('../ipcRules');
var IPCPthFootprintCalculator = require('./pthCalculator.js');

var AxialData = function(position, angle, init) {
    var self = this;
    IpcPthPadGeneratorData.apply(this, arguments);

    this.componentFamily = this.value("componentFamily", true);
    this.componentFamily(PthComponentAttribute.type.AXIAL.family["RESISTOR"]);

    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);

    //3d model lead calculation depends on density level for this package family
    this.update3dModelNonTriggerList.splice(this.update3dModelNonTriggerList.indexOf("densityLevel"), 1);

    this.pitchOverride = this.value("pitchOverride", true);

    this.getPinPitch = this.cachedFunction("getPinPitch",
        function () {
            // update pin pitch based on body length, terminal diameter and density level if override is false
            // pin pitch is used in IPC name, description and metadata
            if (!this.pitchOverride()) {
                var leadInfo = this.getLeadExtensionAndBendRadius();
                return this.bodyWidthMax() + 2 * (leadInfo.radius + leadInfo.extension);
            }

            return this.verticalPinPitch();
        },
        [this.verticalPinPitch, this.bodyWidthMax, this.terminalWidth, this.densityLevel, this.pitchOverride]
    );

    //set default density level (used in model generator mode)
    this.densityLevel(1);
};

lib_core.inherit(AxialData, IpcPthPadGeneratorData);
lib_core.JsonParser.registerClass(AxialData, "AxialData");

module.exports = AxialData;

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
AxialData.prototype.getPads = function(absolutePositions) {
    var pads = [];
    var motif = this.getMotif();
    var hPitch = this.getPinPitch();

    //left pad
    var pad = motif.clone();
    pad.move(new lib_geometry.Coord(-0.5 * hPitch, 0));
    pads.push(pad);

    //right pad
    pad = motif.clone();
    pad.move(new lib_geometry.Coord(0.5 * hPitch, 0));
    pads.push(pad);

    this.updatePads(pads, absolutePositions);

    return pads;
};

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data
 */
AxialData.prototype.getSilkscreen = function(pads) {
    if(pads.length === 0) return;

    var silkscreen = [];
    var body = this.getBodyForSilkscreen();
    var leftPad = pads[0];

    /*
        draw silkscreen on body
     */
    var pathData = new PathData(new lib_geometry.Coord(-body.width / 2, body.height / 2), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, -body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, -body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, body.height / 2), PathType.LINE));

    silkscreen.push(pathData);

    if(this.componentFamily() === PthComponentAttribute.type.AXIAL.family["DIODE"] || this.componentFamily() === PthComponentAttribute.type.AXIAL.family["POLARIZED_CAPACITOR"]) {
        var polaritySilkscreenOffset = body.width / 8;
        pathData = new PathData(new lib_geometry.Coord(-body.width / 2 + polaritySilkscreenOffset, body.height / 2), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2 + polaritySilkscreenOffset, -body.height / 2), PathType.LINE));
        silkscreen.push(pathData);
    }

    /*
        draw extended silkscreen from body to pad in both side
     */
    pathData = new PathData(new lib_geometry.Coord(-body.width / 2, 0), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(leftPad.getPos().x + leftPad.getTopCopper().width() / 2 + IPCRules.silkscreenClearance, 0), PathType.LINE));
    silkscreen.push(pathData);

    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    return silkscreen;
};

AxialData.prototype.getLeadExtensionAndBendRadius = function() {
    //lead extension length
    var leadExtension = 0;
    var leadBendRadiusFactor = 1;

    if(this.terminalWidth() <= IPCRules.axialLeadGoal.thresholds[0]) {
        leadExtension = IPCRules.axialLeadGoal.range1[this.densityLevel()];
        leadBendRadiusFactor = IPCRules.axialLeadGoal.range1[3];
    } else if(this.terminalWidth() > IPCRules.axialLeadGoal.thresholds[0] && this.terminalWidth() <= IPCRules.axialLeadGoal.thresholds[1]) {
        leadExtension = IPCRules.axialLeadGoal.range2[this.densityLevel()];
        leadBendRadiusFactor = IPCRules.axialLeadGoal.range2[3];
    } else if(this.terminalWidth() > IPCRules.axialLeadGoal.thresholds[1]) {
        leadExtension = IPCRules.axialLeadGoal.range3[this.densityLevel()];
        leadBendRadiusFactor = IPCRules.axialLeadGoal.range3[3];
    }

    //lead bend radius/curvature
    //should be greater than half of the lead diameter
    var leadBendRadius = leadBendRadiusFactor * this.terminalWidth();
    if(leadBendRadius < this.terminalWidth() / 2) leadBendRadius = this.terminalWidth() / 2;

    return {
        extension: leadExtension,
        radius: leadBendRadius
    };
};
